import React from "react";
import { Link, useNavigate } from "react-router-dom";
import img from "../constant";
import Button from "./elements/forms/Button";

type Props = {
  title: string;
  className?: string;
  link: string;
};
const Navbar: React.FC<Props> = ({ title, className, link }) => {
  const navigate = useNavigate();

  return (
    <div className="w-full bg-[#fff] py-3 border-b border-[#D9E9FF]">
      <div className="flex justify-between items-center max-w-[1300px] mx-auto px-3">
        <Link to={`/`}>
          <img src={img.logo2} alt="logo" className="md:w-[75px] w-[55px]" />
        </Link>
        <div className="flex items-center">
          <Button
            title={title}
            onSubmitHandler={() => navigate(`${link}`)}
            className={className}
          />
          {/* <div className="w-[10px]"></div>
          <Button
            title={`Login`}
            onSubmitHandler={() => navigate(`/login`)}
            className={`bg-[#2D6EEF] text-[#ffffff]`}
          /> */}
        </div>
      </div>
    </div>
  );
};

export default Navbar;
